import { ESubNodeType } from "./enums";
import rybbit from "@rybbit/js";

export function r2p(rem: number, fallbackBase = 16): number {
  if (typeof window !== "undefined") {
    const baseSize = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    return rem * (baseSize || fallbackBase);
  }
  return rem * fallbackBase; // SSR fallback
}

export const getSubNodeColor = (type: ESubNodeType) => {
  switch (type) {
    case ESubNodeType.Detection:
      return "#007BFF";
    case ESubNodeType.Prevention:
      return "#28A745";
    case ESubNodeType.Treatment:
      return "#FD7E14";
    default:
      return "#6F42C1";
  }
};

export const stringToArrayBuffer = (str: string): ArrayBuffer => {
  const buf = new ArrayBuffer(str.length);
  const bufView = new Uint8Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
};

declare global {
  interface Window {
    rybbit?: {
      trackEvent: (event: string, data: any) => void;
    };
  }
}

export const track = (event: string, data: any) => {
  rybbit.event(event, data);
};

export const pushHistory = () => {
    const state = {
    title: "call",
    url: window.location.hash
    };
    window.history.pushState(state, "call", window.location.hash); 
}


/**
 * 添加popstate监听
 */
export const addListener = (cmd: string, callback: (e: any) => void) => {
  if (window.addEventListener) {
    window.addEventListener(cmd, callback, true);
  }
};

/**
 * 移除popstate监听
 */
export const removeListener = (cmd: string, callback: (e: any) => void) => {
  if (window.removeEventListener) {
    window.removeEventListener(cmd, callback, true);
  }
}
